import React from 'react';
import { useParams } from 'react-router-dom';
import PresentMode from '../components/PresentMode';

export default function PresentViewPage() {
  const { code } = useParams();
  return <PresentMode shareCode={code} onClose={() => window.history.back()} />;
}
